import { Injectable } from '@angular/core';
import { AxiosService } from './../../../core/axios';

@Injectable({
  providedIn: 'root',
})
export class ServiceCenterService {
  constructor(private readonly axiosService: AxiosService) {
    // do noting
  }

  async createServiceCenter(data: any): Promise<any> {
    return this.axiosService.post('/service-center', data);
  }
}
